(function () {
  'use strict';

  angular
    .module('web2print.message')
    .controller('MessageController', MessageController);

  MessageController.$inject = ['$log', '$scope', '$state', '$http', 'Topbar',
    'Common', '$location', 'odrCalendarFactory', 'odrDistributionFactory', '$translate'];

  /* @ngInject */
  function MessageController ($log, $scope, $state, $http, Topbar, Common, $location,
    odrCalendarFactory, odrDistributionFactory, $translate) {
    const vm = this;

    checkSession();

    function checkSession () {
      const action = {
        0: angular.noop,
        1: Common.resetOrderData
      };

      if (Common.get('paymentStatus', false) === 'SUCCESS' || !Common.get('productDelivery', null)) {
        action[Number(Common.get('orderId', null) !== null)]();
        $location.path('/');
        return;
      }

      activate();
    }

    function getPdfApprovedVal () {
      return vm.serviceType === 'admail-odr' ? true : false;
    }

    function activate () {
      vm.language = pnTopbar.language;
      vm.addressType = Common.get('recipients.addressType', null);
      vm.serviceType = Common.get('serviceType', 'information');
      vm.targetType = Common.get('recipients.targetType', null);

      vm.recipients = {
        FILE: parseInt(Common.get('recipients.validAddressCount', 0)),
        COMPANIES: parseInt(Common.get('recipients.refinedAddressCount', 0)),
        INDIVIDUALS: parseInt(Common.get('recipients.refinedAddressCount', 0))
      };

      vm.product = Common.get('productDelivery', {});
      vm.sendoutName = Common.get('sendoutName', null);
      vm.pdfApproved = Common.get('pdfApproved', getPdfApprovedVal());


      vm.showSenderForm = true;
      vm.errorWhenAdding = false;
      vm.isSending = false;
      vm.isSuccess = false;
      vm.isFailed = false;

      // methods
      vm.stfPrinting = stfPrinting;
      vm.getExtraCopies = getExtraCopies;
      vm.completePage = completePage;
      vm.getMaterial = getMaterial;
      vm.goBack = goBack;
      vm.getFormattedSelectedDate = odrCalendarFactory.getFormattedSelectedDate;
      vm.getDeliveryTypeKey = odrCalendarFactory.getDeliveryTypeKey;
      vm.getSubmissionDeadline = odrCalendarFactory.getSubmissionDeadline;
      vm.getSelectedCenter = odrDistributionFactory.getSelectedCenter;

      if (Common.get('serviceType', 'information') === 'admail-odr') {
        vm.odrDimension = Common.get('productDelivery.odrDetails.materialDetails');
      }

      $scope.$on('changeLanguage', function (ev, language) {
        vm.language = language;
      });

      Common.registerObserver('changePdfApproved', changePdfApproved);
    }

    function translate (key) {
      return $translate.instant(key);
    }

    function getMaterial () {
      return translate(vm.product.name) + ', ' + translate(vm.product.format.description);
    }

    function completePage () {
      vm.errorWhenAdding = false;
      Common.set('pdfApproved', vm.pdfApproved);
      $state.go('main.payment');
    }

    function stfPrinting () {
      return Common.get('serviceType', 'information') !== 'admail-odr';
    }

    function getExtraCopies () {
      const targetType = Common.get('recipients.targetType', null);
      const recipients = vm.recipients[targetType];

      let extraCopies = 0;

      if (recipients <= 1000) {
        extraCopies = 50;
      } else if (recipients >= 1001 && recipients <= 5000) {
        extraCopies = 70;
      } else if (recipients >= 5001 && recipients <= 10000) {
        extraCopies = 150;
      } else if (recipients >= 10001 && recipients <= 500000) {
        extraCopies = Math.round(recipients * 0.015);
      }
      return extraCopies;
    }

    function goBack () {
      // should redirect to correct distribution page according to address type
      const states = {
        0: 'main.odrWhereTo',
        1: 'main.whereTo'
      };

      $state.go(states[Number(Common.get('recipients.addressType') !== 'ODR')]);
    }

    function changePdfApproved (pdfApproved) {
      Common.set('pdfApproved', vm.pdfApproved = pdfApproved);
    }
  }
})();
